<template>
  <div>
    <h3 class="title">{{ parseTranslation(SAMPLE_SIZE) }}</h3>

    <div class="field">
      <label class="label" for="wantedCompletes"
        >{{ parseTranslation(WANTED_COMPLETES) }}:</label
      >

      <input
        :class="{ redNumber: wantedCompletes < 1 }"
        id="wantedCompletes"
        v-model.number="wantedCompletes"
        @change="validationWantedCompletes"
        type="number"
        min="1"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import * as translationQuotaPanel from './QuotaPanel.translations'

const { default: translations, ...translationKeys } = translationQuotaPanel

export default {
  props: {
    desiredCompletes: {
      required: false,
    },

    survey: {
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      wantedCompletes: 1,
    }
  },

  methods: {
    ...mapActions(['setWantedCompletes']),

    validationWantedCompletes() {
      if (this.wantedCompletes < 1) this.wantedCompletes = 1

      this.setNumberOfWantedCompletes()
    },

    setNumberOfWantedCompletes() {
      this.setWantedCompletes(Number(this.wantedCompletes))
    },

    calculateWantedCompletes() {
      if (!this.survey?.quota_order || !this.survey?.quota_order?.length) {
        this.wantedCompletes = 0

        return
      }

      const [quotas] = this.survey.quota_order

      const totalWanted = quotas.reduce(
        (acc, quotaString) => acc + this.survey.quota[quotaString],
        0,
      )
      this.wantedCompletes = totalWanted
    },
  },

  created() {
    const desired_completes = this.survey?.sample?.desired_completes

    if (this.survey?.quota && !desired_completes) {
      this.calculateWantedCompletes()
    } else if (desired_completes) {
      this.wantedCompletes = this.desiredCompletes
    }

    this.setNumberOfWantedCompletes()
  },
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  @include tipography(16);
  color: $white;
  font-weight: bold;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
  margin-bottom: 20px;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: $white;
    margin-left: 15px;
  }
}

.field {
  margin-bottom: 20px;
  label {
    @include tipography(14);
    color: $white;
    display: inline-block;
    margin-right: 20px;
    @include d(s) {
      width: unset;
      margin-right: 10px;
    }
  }

  input[type='number'] {
    border: 1px solid $white;
    border-radius: 3px;
    padding: 5px 10px;
    color: $white;
    background: $main-3;
    @include focus;

    &.redNumber {
      color: $red;
    }
  }
}

.light {
  .title {
    color: $main;

    &::after {
      background: $gray-5;
    }
  }

  .field {
    label {
      color: $gray-2;
    }

    input[type='number'] {
      border: 1px solid $gray-5;
      color: $main;
      background: $white;

      &.redNumber {
        color: $red;
      }
    }
  }
}
</style>
